import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import client_lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const {
    serviceTransactionId,
    isVisaFileNumberRequired,
    enableIdentificationInformation,
    hideIdentificationInformation
  } = globalStore.startedService
  const {
    sponsoredUN = '',
    administrativeRegionId = '',
    immigrationDepartmentId = '',
    sponsorTypeId = '',
    withException = ''
  } = router.currentRoute.value.query
  const {
    EnableHandlingOldEmiratesIdExceptionalList,
    allowedAdministrativeRegionsForIcaExcemptions
  } = client_config
  formStore.extraMap = {
    ...formStore.extraMap,
    visaDuarationMsg: '',
    isNewBorn: false,
    serviceTransactionId,
    administrativeRegionId,
    isVisaFileNumberRequired: !!isVisaFileNumberRequired,
    enableIdentificationInformation: !!enableIdentificationInformation,
    hideIdentificationInformation: !!hideIdentificationInformation,
    isNumberOfYearsDisabled: false,
    yearsOfResidency: [],
    enableIcaExcemptions: allowedAdministrativeRegionsForIcaExcemptions.includes(
      parseInt(administrativeRegionId)
    ),
    showQualificationDescription: false,
    isEducationLevelCountryRequired: false,
    withException: withException == 'true'
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    isHumanitarianCaseRequired: 'Required',
    userHadTheOldCardOrCopy: 0,
    manageFields: {}
  }
  if (sponsoredUN) {
    let res = await apiHelperService.get(
      `/api/icaRequest/draft/prepareUnifiedFormForIndividual/${serviceTransactionId}/${sponsoredUN}`
    )
    if (res) {
      const {
        identityNumber,
        familyRelationshipId = '',
        educationLevel = {},
        educationLevelId = '',
        numberOfYears = 1,
        changePersonPhotoFlag = false,
        hasOldEmiratesIdCard = false,
        isFoundInExceptionalList,
        oldEidaExpiryDate = '',
        eidaCardExpiryDate = '',
        genderId = '',
        personUnifiedNumber = '',
        isApplicantHasDisability,
        isApplicantHasSocialPension
      } = res
      const {
        educationLevels: {
          none,
          primaryEducation,
          lowerSecondaryEducation,
          upperSecondaryEducation,
          belowEducationAge,
          diploma,
          bachelor,
          master,
          doctoral,
          highDiploma
        },
        applicationRequestType: { renewIDCard, newIDCard }
      } = client_lookups

      formStore.draft.request = {
        ...formStore.draft.request,
        ...res,
        sponsorRelationshipId: familyRelationshipId,
        qualificationLevelId: educationLevelId,
        isParentInsideUae: 1,
        havePoBox: 0,
        numberOfYears: numberOfYears || 1,
        changePersonPhotoFlag: !!changePersonPhotoFlag ? 1 : 0,
        isApplicantHasDisability: !isApplicantHasDisability ? 0 : isApplicantHasDisability,
        isApplicantHasSocialPension: !isApplicantHasSocialPension ? 0 : isApplicantHasSocialPension,
        applicationRequestTypeId: newIDCard,
        sponsorGenderId: genderId ?? '',
        toKeepPersonUnifiedNumber: personUnifiedNumber
      }
      if (!oldEidaExpiryDate && eidaCardExpiryDate) {
        formStore.draft.request.oldEidaExpiryDate = formStore.draft.request.eidaCardExpiryDate
        formStore.draft.request.manageFields = {
          ...formStore.draft.request.manageFields,
          isOldEidaExpiryDateDisabled: true
        }
      }
      const ifHasOldEmiratesIdCard =
        hasOldEmiratesIdCard && EnableHandlingOldEmiratesIdExceptionalList
      const ifHasIdentityNumber = !!identityNumber && !EnableHandlingOldEmiratesIdExceptionalList
      if (ifHasOldEmiratesIdCard || ifHasIdentityNumber) {
        formStore.draft.request = {
          ...formStore.draft.request,
          applicationRequestTypeId: renewIDCard,
          showOldEidaExpiryDate: true,
          showidentityNumberField: true
        }
        formStore.draft.request.manageFields = {
          ...formStore.draft.request.manageFields,
          isIdentityNumberDisabled: true
        }
        if (!!isFoundInExceptionalList) {
          formStore.draft.request.manageFields = {
            ...formStore.draft.request.manageFields,
            isOldEidaExpiryDateDisabled: false,
            isOldEidaExpiryDateDisabled: false
          }
        }
      }

      if (
        educationLevelId &&
        [
          none,
          primaryEducation,
          lowerSecondaryEducation,
          upperSecondaryEducation,
          belowEducationAge,
          diploma,
          bachelor,
          master,
          doctoral,
          highDiploma
        ].includes(formStore.draft.request.qualificationLevelId)
      ) {
        formStore.extraMap = {
          ...formStore.extraMap,
          showQualificationDescription: true
        }
      }
      if (educationLevel && educationLevel.id > 0) {
        formStore.draft.request = {
          ...formStore.draft.request,
          educationLevelId: educationLevel.id,
          qualificationLevelId: educationLevel.id
        }
        formStore.extraMap = {
          ...formStore.extraMap,
          isEducationLevelCountryRequired: true
        }
      }
    }
  } else {
    if ([556].includes(serviceTransactionId)) {
      formStore.draft.request = {
        ...formStore.draft.request,
        sponsorTypeId,
        immigrationDepartmentId,
        isParentInsideUae: 1
      }
    }
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    formStore.extraMap.individualInfo = res
  }
}

const initRealConfig = async () => {
  const globalStore = useGlobalStore()
  const formStore = useFormStore()

  const {
    startedService: { mainServiceTransactionId },
    languageId
  } = globalStore
  if (mainServiceTransactionId) {
    const {
      newBornParentServiceTransactionId,
      newBornGoldenResidencyParentServiceTransactionId,
      applicationRequestType: { newIDCard },
      passportRelation: { holder },
      applicatClassType: { expat },
      applicantClassDetails: { NewBorn },
      uaeNationality,
      maritalStatuses: { Single },
      workTypes: { notWorking },
      educationLevels: { none },
      gender: { male },
      professions: { child, femaleChild }
    } = client_lookups
    const res = await apiHelperService.get('/api/service/transactions/config', {
      headers: {
        languageId
      },
      params: {
        applicationId: null,
        serviceTransactionId: mainServiceTransactionId,
        administrativeRegionId: 1
      }
    })
    const { transactionId = '', parentServiceId = '', serviceConfig = '' } = res || {}
    formStore.extraMap = {
      ...formStore.extraMap,
      mainServiceTransactionId,
      transactionId
    }
    globalStore.startedService.serviceConfig = {
      ...globalStore.startedService.serviceConfig,
      ...JSON.parse(serviceConfig)
    }
    if (
      [
        newBornParentServiceTransactionId,
        newBornGoldenResidencyParentServiceTransactionId
      ].includes(parentServiceId)
    ) {
      formStore.extraMap = {
        ...formStore.extraMap,
        isNewBorn: true,
        showQualificationDescription: false
      }
      formStore.draft.request.applicationRequestTypeId = newIDCard
    }
    if (formStore.extraMap.isNewBorn) {
      formStore.draft.request = {
        ...formStore.draft.request,
        passportRelationId: holder,
        applicantClassId: expat,
        applicantClassDetailId: NewBorn,
        countryOfBirthId: uaeNationality,
        maritalStatusId: Single,
        workTypeId: notWorking,
        professionId: formStore.draft.request.genderId == male ? child : femaleChild,
        qualificationLevelId: none,
        fatherFileNumber: formStore.extraMap.individualInfo.fileNumber || '',
        showOldEidaExpiryDate: false,
        showidentityNumberField: false
      }
      formStore.draft.request.manageFields = {
        ...formStore.draft.request.manageField,
        isCountryOfBirthIdDisabled: true,
        isProfessionIdDisabled: true,
        isMaritalStatusDisabled: true,
        isWorkTypeIdDisabled: true,
        isQualificationLevelIdDisabled: true
      }
    }
  }
}
export default async function () {
  try {
    await initForm()
    await initInfo()
    await initRealConfig()
  } catch (error) {
    console.error('useIcaServicesPreload error: ', error)
  }
}
